import unblockTripMessagesModule from "./unblockTripMessagesModule"
import unblockTripMessagesDialog from "./unblockTripMessageDialog.html"

unblockTripMessagesModule.service("unblockTripMessageDialog", [
        "$http",
        "$modal",
        "downloadBinary",
        "loadingService",
        function ($http, $modal, downloadBinary, loadingService) {
            return function (message) {
                return $modal.open({
                    template: unblockTripMessagesDialog,
                    size: "xl",
                    backdrop: "static",
                    controller: ["$scope", "unblockTripMessagesService", "remoteExceptionHandler", "messagesModal", "integrationService", function ($scope, unblockTripMessagesService, remoteExceptionHandler, messagesModal, integrationService) {

                        $scope.message = message

                        $scope.breakTable = {
                            records: $scope.message.unblockTripOrderBreaks
                        }

                        $scope.tripTable = {
                            records: $scope.message.unblockTrips
                        }

                        $scope.erpMessagesTable = {
                            records: $scope.message.erpMessages
                        }

                        $scope.dependenciesTable = {
                            records: $scope.message.dependentMessagesIds
                        }

                        $scope.existsUser =  function (){
                            return !!$scope.message.userWhoProcessed
                        }

                        $scope.isIntegrationPublishingTypePULL = false

                        $scope.resendMessage = function () {
                            if ($scope.isIntegrationPublishingTypePULL === true) {
                                return
                            }
                            loadingService(unblockTripMessagesService.resendMessage(message.id))
                                .then(function () {
                                    messagesModal("dialog.success", [{
                                        keyBundle: "interface.unblockTripMessage.modal.resendMessageSucceed",
                                        parameters: [message.id]
                                    }])
                                }).catch(remoteExceptionHandler())
                        }

                        $scope.getIntegrationPublishingType = function () {
                            loadingService(integrationService.getPublishingType())
                                .then(function (result) {
                                    if (result === "br.com.neolog.model.parameters.integration.PublishingType.PULL") {
                                        $scope.isIntegrationPublishingTypePULL = true
                                    }
                                })
                        }
                        $scope.getIntegrationPublishingType()
                    }]
                })

            }
        }
    ])